import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { Star } from 'lucide-react';
export function Hero() {
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return 10 * 60; // Reset to 10 minutes when it reaches 0
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section className="relative md:pt-24 bg-brand-cream overflow-hidden pt-[10px] pb-[10px]" data-id="element-111">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl relative z-10" data-id="element-112">
        <div className="flex flex-col md:flex-row items-center md:gap-20 gap-[21px]" data-id="element-113">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left mt-[0px] mb-[0px]" data-id="element-114">
            <div className="inline-flex items-center px-4 py-2 rounded-full border border-brand-beige bg-brand-cream text-brand-violet text-xs font-medium pt-[8px] pb-[8px] pl-[16px] pr-[16px] mt-[0px] mb-[0px] gap-[8px]" data-id="element-115">
              <div className="flex text-brand-champagne" data-id="element-116">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-117" />)}
              </div>
              <span className="text-[#856F95]" data-id="element-118">
                +200 MUJERES YA INICIARON SU VIAJE INTERIOR
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight mb-6 text-balance text-brand-dark pt-[5px] pb-[5px]" data-id="element-119">
              Dejá de repetir los mismos patrones y empezá a entenderte de
              verdad en solo 60 días.
            </h1>
            <p className="text-base md:text-lg text-brand-light mb-8 max-w-xl mx-auto md:mx-0 leading-relaxed" data-id="element-120">
              Con <strong data-id="element-121">Viaje a tu Interior</strong> vas a poder{' '}
              <strong data-id="element-122">mirar hacia adentro</strong>, entender{' '}
              <strong data-id="element-123">de dónde vienen tus patrones</strong> y{' '}
              <strong data-id="element-124">empezar a soltarlos</strong>, incluso si nunca hiciste
              journaling o sentís que no sabés por dónde empezar.
            </p>

            <div className="flex flex-col items-center md:items-start gap-4 mt-8 w-full" data-id="element-125">
              <Button className="w-full md:w-auto text-lg px-10 py-5 group" data-id="element-126">
                QUIERO EMPEZAR MI VIAJE
              </Button>
            </div>
          </div>

          {/* Image/Mockup */}
          <div className="flex-1 relative w-full max-w-md mx-auto md:max-w-none" data-id="element-127"></div>
        </div>
      </div>
    </section>;
}